import { Box, Container, Text } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

import { ColorModeButton } from '@/components/ui/color-mode';

export const Route = createFileRoute('/_layout/$slug/profile')({
  component: Profile,
});

function Profile() {
  const auth = useAuth();
  const { t } = useTranslation();

  const fullName = `${auth.user?.profile?.family_name}${auth.user?.profile?.name}` || auth.user?.profile?.email;

  return (
    <Container maxW="full">
      <Box pt={12} m={4}>
        <Text fontSize="2xl">{t('profile.title', { fullname: fullName })}</Text>
        <Text>{t('profile.welcome')}</Text>
        <Text>{t('profile.profileLabel')}</Text>
        <ColorModeButton />
      </Box>
    </Container>
  );
}
